import Vue from 'vue';
import _Vue from 'vue';
import getAppData from '@/modules/AppData';

Vue.use({
  install(Vue: typeof _Vue) {
    Vue.prototype.$getAppData = getAppData;
  }
});